<template>
   <v-container>
      <v-snackbar v-model="snackbar" :color="snackColor" bottom right :timeout="4000">
         {{ snackText }}
         <template #action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
         </template>
      </v-snackbar>

      <!-- Dialog anular -->
      <v-dialog v-model="dialogAnular" persistent max-width="520">
         <v-card>
            <v-card-title class="text-h6">
               Anular {{ pagoSeleccionado && pagoSeleccionado.esGrupo ? 'Grupo de Pagos' : 'Pago' }}
            </v-card-title>
            <v-card-text>
               <p class="mb-1">
                  <strong>Carnet:</strong> {{ pagoSeleccionado && pagoSeleccionado.alumnoCarnet }}<br />
                  <template v-if="pagoSeleccionado && pagoSeleccionado.esGrupo">
                     <strong>Autorización:</strong> {{ pagoSeleccionado.autorizacion }}<br />
                     <strong>Referencia:</strong> {{ pagoSeleccionado.referencia }}<br />
                     <strong>Pagos en el grupo:</strong> {{ pagoSeleccionado.cantidad }}<br />
                  </template>
                  <template v-else>
                     <strong>Concepto:</strong> {{ pagoSeleccionado && pagoSeleccionado.concepto }}<br />
                  </template>
                  <strong>Monto{{ pagoSeleccionado && pagoSeleccionado.esGrupo ? ' total' : '' }}:</strong>
                  ${{ pagoSeleccionado ? Number(pagoSeleccionado.monto).toFixed(2) : '' }}
               </p>

               <v-simple-table
                  v-if="pagoSeleccionado && pagoSeleccionado.esGrupo"
                  dense
                  class="grupo-detalle mt-2"
               >
                  <tbody>
                     <tr v-for="p in pagoSeleccionado.pagos" :key="p.pagoId">
                        <td>{{ p.concepto }}</td>
                        <td class="text-right">${{ Number(p.monto).toFixed(2) }}</td>
                     </tr>
                  </tbody>
               </v-simple-table>

               <v-alert
                  v-if="pagoSeleccionado && pagoSeleccionado.esGrupo"
                  dense
                  text
                  type="warning"
                  class="caption mt-3 mb-0"
               >
                  Se anularán los {{ pagoSeleccionado.cantidad }} pagos del grupo en una sola operación.
               </v-alert>

               <v-textarea
                  v-model="motivoAnulacion"
                  label="Motivo de anulación"
                  :rules="[v => !!v || 'Ingrese el motivo']"
                  rows="3"
                  outlined
                  class="mt-3"
               ></v-textarea>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn text @click="dialogAnular = false">Cancelar</v-btn>
               <v-btn color="error" :disabled="!motivoAnulacion" :loading="loadingAnular" @click="confirmarAnular">
                  Anular
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <!-- Animación envío de correo -->
      <v-dialog v-model="dialogCorreo" persistent max-width="360">
         <v-card class="text-center py-6 px-4">
            <div class="correo-wrapper mb-4">
               <v-icon class="correo-icono" size="64" color="primary">fas fa-envelope</v-icon>
               <v-icon class="check-icono" size="32" color="success">fas fa-check-circle</v-icon>
            </div>
            <div class="text-h6 font-weight-bold mb-1">Notificación enviada</div>
            <div class="body-2 grey--text">
               Se ha notificado al departamento de contabilidad sobre la anulación del pago.
            </div>
         </v-card>
      </v-dialog>

      <!-- Dialog reactivar -->
      <v-dialog v-model="dialogReactivar" persistent max-width="480">
         <v-card>
            <v-card-title class="text-h6">
               Reactivar {{ pagoAnuladoSeleccionado && pagoAnuladoSeleccionado.esGrupo ? 'Grupo de Pagos' : 'Pago' }}
            </v-card-title>
            <v-card-text>
               <template v-if="pagoAnuladoSeleccionado && pagoAnuladoSeleccionado.esGrupo">
                  ¿Está seguro que desea reactivar los {{ pagoAnuladoSeleccionado.cantidad }} pagos del grupo?
                  <p class="mt-2 mb-1">
                     <strong>Carnet:</strong> {{ pagoAnuladoSeleccionado.alumnoCarnet }}<br />
                     <strong>Autorización:</strong> {{ pagoAnuladoSeleccionado.autorizacion }}<br />
                     <strong>Referencia:</strong> {{ pagoAnuladoSeleccionado.referencia }}
                  </p>
                  <v-simple-table dense class="grupo-detalle mt-2">
                     <tbody>
                        <tr v-for="p in pagoAnuladoSeleccionado.anulados" :key="p.pagoAnuladoId">
                           <td>{{ p.concepto }}</td>
                           <td class="text-right">${{ Number(p.monto).toFixed(2) }}</td>
                        </tr>
                     </tbody>
                  </v-simple-table>
               </template>
               <template v-else>
                  ¿Está seguro que desea reactivar este pago?
                  <p class="mt-2">
                     <strong>Carnet:</strong> {{ pagoAnuladoSeleccionado && pagoAnuladoSeleccionado.alumnoCarnet }}<br />
                     <strong>Concepto original:</strong> {{ pagoAnuladoSeleccionado && pagoAnuladoSeleccionado.concepto }}
                  </p>
               </template>
            </v-card-text>
            <v-card-actions>
               <v-spacer></v-spacer>
               <v-btn text @click="dialogReactivar = false">Cancelar</v-btn>
               <v-btn color="primary" :loading="loadingReactivar" @click="confirmarReactivar">
                  Reactivar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-card elevation="0" outlined>
         <v-toolbar color="primary" dark>
            <v-toolbar-title>Historial de Pagos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
               v-if="accessCode"
               dark
               text
               @click="irColecturiaDigital"
            >
               <v-icon left>fas fa-store</v-icon>
               Colecturía Digital
            </v-btn>
         </v-toolbar>

         <!-- Filtros -->
         <v-card-text class="pb-1">
            <v-row dense>
               <v-col cols="12" sm="6">
                  <v-text-field
                     v-model="filtroCarnet"
                     label="Carnet del alumno"
                     clearable
                     outlined
                     dense
                     @keyup.enter="buscar"
                  ></v-text-field>
               </v-col>
               <v-col cols="12" sm="3">
                  <v-autocomplete
                     v-model="filtroCiclo"
                     :items="ciclos"
                     item-text="label"
                     item-value="value"
                     label="Ciclo"
                     clearable
                     outlined
                     dense
                  ></v-autocomplete>
               </v-col>
               <v-col cols="12" sm="3" class="d-flex align-center">
                  <v-btn color="primary" block :loading="loadingBuscar" @click="buscar">
                     <v-icon left>fas fa-search</v-icon> Buscar
                  </v-btn>
               </v-col>
            </v-row>
            <v-row align="center" dense class="mt-0">
               <v-col cols="auto" class="py-0 pr-1">
                  <span class="caption grey--text text--darken-2 font-weight-medium">Año</span>
               </v-col>
               <v-col class="py-0">
                  <v-chip-group v-model="filtroAnnio" multiple>
                     <v-chip
                        v-for="a in annios"
                        :key="a"
                        :value="a"
                        small
                        filter
                        color="primary"
                        :outlined="!filtroAnnio.includes(a)"
                     >{{ a }}</v-chip>
                  </v-chip-group>
               </v-col>
            </v-row>
         </v-card-text>

         <v-tabs v-model="tab" class="tabs-outline px-4 pt-3 pb-1">
            <v-tab>Pagos</v-tab>
            <v-tab>Pagos Anulados</v-tab>
         </v-tabs>

         <v-tabs-items v-model="tab">
            <!-- TAB: PAGOS ACTIVOS -->
            <v-tab-item>
               <div class="tabla-scroll">
               <v-data-table
                  :headers="headersPagos"
                  :items="filasPagos"
                  :loading="loadingBuscar"
                  :items-per-page="15"
                  :footer-props="{ itemsPerPageText: 'Filas por página:' }"
                  item-key="id"
                  show-expand
                  single-expand
                  :expanded.sync="expanded"
                  class="elevation-0 tabla-compacta"
               >
                  <!-- Solo los grupos muestran el botón de expandir -->
                  <template #item.data-table-expand="{ item, isExpanded, expand }">
                     <v-btn
                        v-if="item.esGrupo"
                        icon
                        small
                        @click="expand(!isExpanded)"
                     >
                        <v-icon small>{{ isExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
                     </v-btn>
                  </template>

                  <template #item.concepto="{ item }">
                     <template v-if="item.esGrupo">
                        <v-chip x-small color="primary" outlined class="mr-1">{{ item.cantidad }} pagos</v-chip>
                        <span>{{ item.conceptos }}</span>
                     </template>
                     <template v-else>{{ item.concepto }}</template>
                  </template>

                  <template #item.monto="{ item }">
                     ${{ Number(item.monto).toFixed(2) }}
                  </template>

                  <template #item.opciones="{ item }">
                     <v-btn
                        small
                        color="error"
                        text
                        @click="abrirDialogAnular(item)"
                     >
                        <v-icon small>fas fa-ban</v-icon>
                        <span class="ml-1">Anular</span>
                     </v-btn>
                  </template>

                  <!-- Detalle de los pagos del grupo -->
                  <template #expanded-item="{ headers, item }">
                     <td :colspan="headers.length" class="pa-0">
                        <div class="grupo-detalle-expandido pa-3">
                           <div class="caption font-weight-bold mb-2">
                              Pagos del grupo — Autorización {{ item.autorizacion }} · Referencia {{ item.referencia }}
                           </div>
                           <v-simple-table dense class="grupo-detalle">
                              <thead>
                                 <tr>
                                    <th class="text-left">Concepto</th>
                                    <th class="text-right">Monto</th>
                                    <th class="text-left">Fecha</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="p in item.pagos" :key="p.pagoId">
                                    <td>{{ p.concepto }}</td>
                                    <td class="text-right">${{ Number(p.monto).toFixed(2) }}</td>
                                    <td>{{ p.fecha }}</td>
                                 </tr>
                              </tbody>
                           </v-simple-table>
                        </div>
                     </td>
                  </template>
               </v-data-table>
               </div>
            </v-tab-item>

            <!-- TAB: PAGOS ANULADOS -->
            <v-tab-item>
               <div class="tabla-scroll">
               <v-data-table
                  :headers="headersPagosAnulados"
                  :items="filasAnulados"
                  :loading="loadingAnulados"
                  :items-per-page="15"
                  :footer-props="{ itemsPerPageText: 'Filas por página:' }"
                  item-key="id"
                  show-expand
                  single-expand
                  :expanded.sync="expandedAnulados"
                  class="elevation-0 tabla-compacta tabla-anulados-dense"
                  dense
               >
                  <!-- Solo los grupos muestran el botón de expandir -->
                  <template #item.data-table-expand="{ item, isExpanded, expand }">
                     <v-btn
                        v-if="item.esGrupo"
                        icon
                        x-small
                        @click="expand(!isExpanded)"
                     >
                        <v-icon x-small>{{ isExpanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down' }}</v-icon>
                     </v-btn>
                  </template>

                  <template #item.concepto="{ item }">
                     <template v-if="item.esGrupo">
                        <v-chip x-small color="primary" outlined class="mr-1">{{ item.cantidad }} pagos</v-chip>
                        <span>{{ item.conceptos }}</span>
                     </template>
                     <template v-else>{{ item.concepto }}</template>
                  </template>

                  <template #item.monto="{ item }">
                     ${{ Number(item.monto).toFixed(2) }}
                  </template>
                  <template #item.usuarioAnulacion="{ item }">
                     {{ item.usuarioAnulacion || '—' }}
                  </template>
                  <template #item.fechaReversion="{ item }">
                     {{ item.fechaReversion || '—' }}
                  </template>
                  <template #item.usuarioReactivacion="{ item }">
                     {{ item.usuarioReactivacion || '—' }}
                  </template>
                  <template #item.opciones="{ item }">
                     <v-btn
                        v-if="item.esGrupo || !item.fechaReversion"
                        small
                        color="success"
                        text
                        @click="abrirDialogReactivar(item)"
                     >
                        <v-icon small>fas fa-undo</v-icon>
                        <span class="ml-1">Reactivar</span>
                     </v-btn>
                  </template>

                  <!-- Detalle de los pagos del grupo anulado -->
                  <template #expanded-item="{ headers, item }">
                     <td :colspan="headers.length" class="pa-0">
                        <div class="grupo-detalle-expandido pa-3">
                           <div class="caption font-weight-bold mb-2">
                              Pagos del grupo — Autorización {{ item.autorizacion }} · Referencia {{ item.referencia }}
                           </div>
                           <v-simple-table dense class="grupo-detalle">
                              <thead>
                                 <tr>
                                    <th class="text-left">Concepto</th>
                                    <th class="text-right">Monto</th>
                                    <th class="text-left">Fecha Pago</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr v-for="p in item.anulados" :key="p.pagoAnuladoId">
                                    <td>{{ p.concepto }}</td>
                                    <td class="text-right">${{ Number(p.monto).toFixed(2) }}</td>
                                    <td>{{ p.fecha }}</td>
                                 </tr>
                              </tbody>
                           </v-simple-table>
                        </div>
                     </td>
                  </template>
               </v-data-table>
               </div>
            </v-tab-item>
         </v-tabs-items>
      </v-card>
   </v-container>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'

function serializeParams(params) {
   return Object.entries(params)
      .flatMap(([k, v]) => Array.isArray(v) ? v.map(i => `${k}=${encodeURIComponent(i)}`) : [`${k}=${encodeURIComponent(v)}`])
      .join('&')
}

export default {
   name: 'HistorialDePagos',
   computed: {
      ...authComputed,
      // Agrupa los pagos con misma autorización + misma referencia (todos son
      // ResponseCode 00 porque el backend ya los filtra). Los grupos de 2 o más
      // se colapsan en una sola fila expandible; el resto queda como fila individual.
      filasPagos() {
         const grupos = new Map()
         const orden = []
         this.pagos.forEach((p) => {
            const clave = p.autorizacion && p.referencia
               ? `${p.autorizacion}||${p.referencia}`
               : null
            if (clave) {
               if (!grupos.has(clave)) {
                  grupos.set(clave, [])
                  orden.push({ tipo: 'grupo', clave })
               }
               grupos.get(clave).push(p)
            } else {
               orden.push({ tipo: 'solo', pago: p })
            }
         })

         const filas = []
         orden.forEach((o) => {
            if (o.tipo === 'solo') {
               filas.push(this.filaDesdePago(o.pago))
               return
            }
            const lista = grupos.get(o.clave)
            if (lista.length === 1) {
               filas.push(this.filaDesdePago(lista[0]))
            } else {
               filas.push({
                  esGrupo: true,
                  id: 'g:' + o.clave,
                  alumnoCarnet: lista[0].alumnoCarnet,
                  fecha: lista[0].fecha,
                  concepto: `${lista.length} pagos agrupados`,
                  conceptos: lista.map((x) => x.concepto).join(', '),
                  monto: lista.reduce((s, x) => s + Number(x.monto || 0), 0),
                  autorizacion: lista[0].autorizacion,
                  referencia: lista[0].referencia,
                  cantidad: lista.length,
                  pagos: lista
               })
            }
         })
         return filas
      },
      // Agrupa los pagos anulados NO revertidos con misma autorización + referencia
      // (los que se anularon juntos como grupo) para poder reactivarlos de una sola vez.
      // Los ya revertidos y los individuales quedan como filas sueltas.
      filasAnulados() {
         const grupos = new Map()
         const orden = []
         this.pagosAnulados.forEach((p) => {
            const agrupable = !p.fechaReversion && p.autorizacion && p.referencia
            const clave = agrupable ? `${p.autorizacion}||${p.referencia}` : null
            if (clave) {
               if (!grupos.has(clave)) {
                  grupos.set(clave, [])
                  orden.push({ tipo: 'grupo', clave })
               }
               grupos.get(clave).push(p)
            } else {
               orden.push({ tipo: 'solo', pago: p })
            }
         })

         const filas = []
         orden.forEach((o) => {
            if (o.tipo === 'solo') {
               filas.push(this.filaAnuladoDesde(o.pago))
               return
            }
            const lista = grupos.get(o.clave)
            if (lista.length === 1) {
               filas.push(this.filaAnuladoDesde(lista[0]))
            } else {
               const first = lista[0]
               filas.push({
                  esGrupo: true,
                  id: 'ga:' + o.clave,
                  alumnoCarnet: first.alumnoCarnet,
                  fecha: first.fecha,
                  concepto: `${lista.length} pagos agrupados`,
                  conceptos: lista.map((x) => x.concepto).join(', '),
                  monto: lista.reduce((s, x) => s + Number(x.monto || 0), 0),
                  autorizacion: first.autorizacion,
                  referencia: first.referencia,
                  fechaAnulacion: first.fechaAnulacion,
                  usuarioAnulacion: first.usuarioAnulacion,
                  fechaReversion: null,
                  usuarioReactivacion: null,
                  cantidad: lista.length,
                  anulados: lista
               })
            }
         })
         return filas
      }
   },
   data: () => ({
      tab: 0,
      filtroCarnet: '',
      filtroAnnio: [],
      filtroCiclo: null,
      pagos: [],
      expanded: [],
      pagosAnulados: [],
      expandedAnulados: [],
      loadingBuscar: false,
      loadingAnulados: false,
      snackbar: false,
      snackText: '',
      snackColor: 'success',
      dialogAnular: false,
      motivoAnulacion: '',
      pagoSeleccionado: null,
      loadingAnular: false,
      dialogCorreo: false,
      dialogReactivar: false,
      pagoAnuladoSeleccionado: null,
      loadingReactivar: false,
      accessCode: '',
      annios: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i),
      ciclos: [
         { label: 'Ciclo I', value: 1 },
         { label: 'Ciclo II', value: 2 }
      ],
      headersPagos: [
         { text: 'Carnet',       value: 'alumnoCarnet', width: '110px' },
         { text: 'Fecha',        value: 'fecha',        width: '140px' },
         { text: 'Concepto',     value: 'concepto',     width: '220px' },
         { text: 'Monto',        value: 'monto',        width: '90px' },
         { text: 'Autorización', value: 'autorizacion', width: '130px' },
         { text: 'Acciones',     value: 'opciones',     width: '100px', sortable: false }
      ],
      headersPagosAnulados: [
         { text: 'Carnet',          value: 'alumnoCarnet',        width: '90px' },
         { text: 'Fecha Pago',      value: 'fecha',               width: '110px' },
         { text: 'Concepto',        value: 'concepto',            width: '150px' },
         { text: 'Monto',           value: 'monto',               width: '70px' },
         { text: 'Fecha Anulación', value: 'fechaAnulacion',      width: '110px' },
         { text: 'Anulado por',     value: 'usuarioAnulacion',    width: '110px' },
         { text: 'Fecha Reversión', value: 'fechaReversion',      width: '110px' },
         { text: 'Reactivado por',  value: 'usuarioReactivacion', width: '110px' },
         { text: 'Acciones',        value: 'opciones',            width: '90px', sortable: false }
      ]
   }),
   created() {
      this.cargarAnulados()
   },
   methods: {
      buscar() {
         if (!this.filtroCarnet) {
            this.snackText = 'Ingrese un carnet para buscar.'
            this.snackColor = 'warning'
            this.snackbar = true
            return
         }
         this.accessCode = ''
         this.loadingBuscar = true
         const params = { carnet: this.filtroCarnet }
         if (this.filtroAnnio && this.filtroAnnio.length > 0) params.annio = this.filtroAnnio
         if (this.filtroCiclo) params.ciclo = this.filtroCiclo

         axios
            .get('api/PagoAnulado/Pagos', { params, paramsSerializer: p => serializeParams(p) })
            .then((r) => { this.pagos = r.data })
            .catch(() => {
               this.snackText = 'Error al obtener los pagos.'
               this.snackColor = 'error'
               this.snackbar = true
            })
            .finally(() => { this.loadingBuscar = false })

         this.cargarAnulados()

         // Obtener accessCode para el enlace de Colecturía Digital
         axios
            .get('api/Alumno/Credenciales?carnet=' + this.filtroCarnet)
            .then((r) => {
               if (r.data && r.data[0]) this.accessCode = r.data[0].accessCode
            })
            .catch(() => {})
      },
      cargarAnulados() {
         this.loadingAnulados = true
         const params = {}
         if (this.filtroAnnio && this.filtroAnnio.length > 0) params.annio = this.filtroAnnio
         if (this.filtroCiclo) params.ciclo = this.filtroCiclo
         if (this.filtroCarnet) params.carnet = this.filtroCarnet

         axios
            .get('api/PagoAnulado/Anulados', { params, paramsSerializer: p => serializeParams(p) })
            .then((r) => { this.pagosAnulados = r.data })
            .catch(() => {
               this.snackText = 'Error al obtener los pagos anulados.'
               this.snackColor = 'error'
               this.snackbar = true
            })
            .finally(() => { this.loadingAnulados = false })
      },
      // Convierte un pago individual en una fila de la tabla (mismo formato que un grupo)
      filaDesdePago(p) {
         return {
            esGrupo: false,
            id: 'p:' + p.pagoId,
            alumnoCarnet: p.alumnoCarnet,
            fecha: p.fecha,
            concepto: p.concepto,
            monto: Number(p.monto || 0),
            autorizacion: p.autorizacion,
            referencia: p.referencia,
            cantidad: 1,
            pagos: [p]
         }
      },
      abrirDialogAnular(fila) {
         this.pagoSeleccionado = fila
         this.motivoAnulacion = ''
         this.dialogAnular = true
      },
      confirmarAnular() {
         this.loadingAnular = true
         const usuario = this.oidcUser ? this.oidcUser.name : 'Desconocido'
         const fila = this.pagoSeleccionado
         const peticion = fila.esGrupo
            ? axios.post('api/PagoAnulado/AnularGrupo', {
                 pagoIds: fila.pagos.map((p) => p.pagoId),
                 concepto: this.motivoAnulacion,
                 usuario
              })
            : axios.post('api/PagoAnulado/Anular', {
                 pagoId: fila.pagos[0].pagoId,
                 concepto: this.motivoAnulacion,
                 usuario
              })

         peticion
            .then(() => {
               this.dialogAnular = false
               this.buscar()
               this.cargarAnulados()
               // Mostrar animación de correo enviado y cerrarla sola a los 3s
               this.dialogCorreo = true
               setTimeout(() => { this.dialogCorreo = false }, 3000)
            })
            .catch(() => {
               this.snackText = fila.esGrupo
                  ? 'Error al anular el grupo de pagos.'
                  : 'Error al anular el pago.'
               this.snackColor = 'error'
               this.snackbar = true
            })
            .finally(() => { this.loadingAnular = false })
      },
      // Convierte un pago anulado individual en una fila (mismo formato que un grupo)
      filaAnuladoDesde(p) {
         return {
            esGrupo: false,
            id: 'pa:' + p.pagoAnuladoId,
            pagoAnuladoId: p.pagoAnuladoId,
            alumnoCarnet: p.alumnoCarnet,
            fecha: p.fecha,
            concepto: p.concepto,
            monto: Number(p.monto || 0),
            autorizacion: p.autorizacion,
            referencia: p.referencia,
            fechaAnulacion: p.fechaAnulacion,
            usuarioAnulacion: p.usuarioAnulacion,
            fechaReversion: p.fechaReversion,
            usuarioReactivacion: p.usuarioReactivacion,
            cantidad: 1,
            anulados: [p]
         }
      },
      abrirDialogReactivar(fila) {
         this.pagoAnuladoSeleccionado = fila
         this.dialogReactivar = true
      },
      irColecturiaDigital() {
         window.open(
            process.env.VUE_APP_CLIENTE +
               'colecturiaDigital?carnet=' +
               this.filtroCarnet.trim().toUpperCase() +
               '&accesscode=' +
               this.accessCode,
            '_blank'
         )
      },
      confirmarReactivar() {
         this.loadingReactivar = true
         const usuario = this.oidcUser ? this.oidcUser.name : 'Desconocido'
         const fila = this.pagoAnuladoSeleccionado
         const peticion = fila.esGrupo
            ? axios.post('api/PagoAnulado/ReactivarGrupo', {
                 pagoAnuladoIds: fila.anulados.map((p) => p.pagoAnuladoId),
                 usuario
              })
            : axios.post(`api/PagoAnulado/Reactivar/${fila.pagoAnuladoId}?usuario=${encodeURIComponent(usuario)}`)

         peticion
            .then(() => {
               this.snackText = fila.esGrupo
                  ? 'Grupo de pagos reactivado correctamente.'
                  : 'Pago reactivado correctamente.'
               this.snackColor = 'success'
               this.snackbar = true
               this.dialogReactivar = false
               this.cargarAnulados()
               if (this.filtroCarnet) this.buscar()
            })
            .catch(() => {
               this.snackText = fila.esGrupo
                  ? 'Error al reactivar el grupo de pagos.'
                  : 'Error al reactivar el pago.'
               this.snackColor = 'error'
               this.snackbar = true
            })
            .finally(() => { this.loadingReactivar = false })
      }
   }
}
</script>

<style scoped>
/* ── Tabs como botones outline ── */
.tabs-outline ::v-deep .v-tabs-bar {
   background-color: transparent !important;
   height: auto !important;
}

.tabs-outline ::v-deep .v-tab {
   border: 2px solid #6C1C19 !important;
   border-radius: 6px !important;
   margin-right: 8px !important;
   color: #6C1C19 !important;
   background-color: #FFFFFF !important;
   font-weight: 600 !important;
   min-width: 130px !important;
   height: 36px !important;
   text-transform: none !important;
   letter-spacing: 0 !important;
}

.tabs-outline ::v-deep .v-tab--active {
   background-color: #6C1C19 !important;
   color: #FFFFFF !important;
}

.tabs-outline ::v-deep .v-tab:hover:not(.v-tab--active) {
   background-color: rgba(108, 28, 25, 0.08) !important;
}

.tabs-outline ::v-deep .v-tabs-slider-wrapper {
   display: none !important;
}

/* Scroll horizontal para tablas con muchas columnas */
.tabla-scroll {
   width: 100%;
   overflow-x: auto;
}

/* Evita que el texto desborde las celdas */
.tabla-compacta ::v-deep td,
.tabla-compacta ::v-deep th {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   max-width: 220px;
}

/* La columna concepto puede mostrar más texto */
.tabla-compacta ::v-deep td:nth-child(3) {
   white-space: normal;
   word-break: break-word;
}

/* Tabla de anulados: fuente y celdas más pequeñas para caber en pantalla */
.tabla-anulados-dense ::v-deep td,
.tabla-anulados-dense ::v-deep th {
   font-size: 11px !important;
   padding: 0 8px !important;
   max-width: 160px;
}

.tabla-anulados-dense ::v-deep .v-btn {
   font-size: 10px !important;
   padding: 0 4px !important;
   height: 24px !important;
   min-width: unset !important;
}

/* Detalle de un grupo de pagos (fila expandida y diálogo) */
.grupo-detalle-expandido {
   background: #FAFAFA;
   border-bottom: 1px solid #E0E0E0;
}

.grupo-detalle ::v-deep table {
   background: transparent;
}

.grupo-detalle ::v-deep td,
.grupo-detalle ::v-deep th {
   font-size: 12px !important;
   height: 30px !important;
   white-space: nowrap;
}

.correo-wrapper {
   position: relative;
   display: inline-block;
}

.correo-icono {
   animation: volar 0.7s ease-out forwards;
}

.check-icono {
   position: absolute;
   bottom: -6px;
   right: -10px;
   animation: aparecer 0.4s ease-out 0.6s both;
}

@keyframes volar {
   0%   { transform: translateY(20px) scale(0.7); opacity: 0; }
   60%  { transform: translateY(-8px) scale(1.1); opacity: 1; }
   100% { transform: translateY(0)    scale(1);   opacity: 1; }
}

@keyframes aparecer {
   0%   { transform: scale(0); opacity: 0; }
   100% { transform: scale(1); opacity: 1; }
}
</style>
